import TR from 'utils/TR';
import usePeriodAction from 'hooks/actions/usePeriodAction';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';

export default function PeriodButton(props) {
  const {
    days,
    label,
    basis,
    ...rest
  } = props || {};
  const {
    triggered,
    onTrigger,
    // -14/14일이 들어오면 -13/13일로 변경. luxon은 오늘이 0일차지만 앱에서는 1일차이기 때문
  } = usePeriodAction(Math.sign(days) * (Math.abs(days) - 1));
  return (
    <FocusableButton
      {...ex(['PeriodButton', { triggered }], rest)}
      {...{ onClick: onTrigger() }}
    >
      {T('{0}일', label || Math.abs(days))}
    </FocusableButton>
  );
}
